import React, { FunctionComponent, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MainButton from '../../components/MainButton';
import StatusMessage from '../../components/StatusMessage';
import { RootState } from '../../redux/reducers';
import { Body, WhiteContainer, Title, RegularPrice, Price } from '../../theme/theme'; 
import { error } from "../../notifications/displayMessage";

import {
    AddressInfo,
    InfoCardContainer,
    PurchaseResumeInfo,
    InvoiceContainer,
    PaymentInfo,
    ProductsPurchasedContainer,
    ProductPurchasedCard,
    ProductPurchasedImage,
    ProductPurchasedInfo,
    CancelButton,
    ErrorStateCard,
    ErrorStateSurface,
    ErroContainer,
    PaymentMethodImg,
    ButtonsActions,
    DiscountColoredText
} from './style';
import { useHistory, useParams } from 'react-router';
import config, { domain, epaycoMultimedia, path } from "../../config/enviroment";
import { callDataConfingClientOwner, handleFetchPurchase, validateShoppingCart } from '../../redux/actions';
import useQuery from '../../hooks/useQuery';
import Spinner from '../../components/Spinner';
import { LoadContainer } from '../ProductInfo/style';
import Axios from 'axios';
import { EpaycoCheckout } from '../../utils/epaycoCheckout';
import CurrencyFormat from '../../utils/currencyFormat';
import loadCheckout from '../../utils/loadCheckout.js';
import { CustomIcon } from '../../components/CustomIcon';
import PurchasePdf  from '../../components/PurchasePdf';
import { ShippingDetail, ShippingInfo } from '../../hooks/ShippingDetail';
import {v4 as uuid} from 'uuid'
import { language } from '../../utils/language';
import AddFrom from '../../components/AddFrom';
import {calculatePriceWithTax, findAmountProduct, returnProduct} from '../../utils/formatData'
import PurchaseDetailAveonline from './PurchaseDetailAveonline';
import PurchasePdfAveonline from '../../components/PurchasePdfAveonline';
import { parseInvoiceTest, parseTestRequest } from '../../utils/parseTestMode';
import CartValidationModal from '../../components/CartValidationModal';
import { getCartValidationError, CartValidationResult } from '../../utils/cartValidation';
import { INACTIVE_CATALOGUE } from '../../redux/actions/homeActions';
import { wasShippingFree } from '../../utils/shippingRules';

const PurchaseDetail: FunctionComponent = () => {
    const [loadScript, setLoadScript] = useState(true);
    const [subTotalAmount, setSubTotalAmount] = useState(0);

    
    const [totalDiscountAmount, setTotalDiscountAmount] = useState(0);
    let payment:any = useRef(0);
    const [loading, setLoading] = useState(false);
    const [cartValidation, setCartValidation] = useState<CartValidationResult | null>(null);
    const [transactionState, setTransactionState] = useState<{
        refEpayco: string,
        cardNumber: string,
        transactionDate: string,
        transactionTime: string,
        paymentMethodId: string,
        isTestTransaction: boolean | null,
    }>({
        refEpayco: '',
        cardNumber: '',
        transactionDate: '',
        transactionTime: '',
        paymentMethodId: '',
        isTestTransaction: null
    });
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);
    const purchase: any = useSelector((state: RootState) => state.purchase);
    const history = useHistory();
    const dispatch = useDispatch();
    const { idCart }: any = useParams();
    const query = useQuery();
    const refPayco = query.get('ref_payco');

  

    useEffect(() => {
        if(config.epaycoPurchaseReference && refPayco)
            Axios.get(config.epaycoPurchaseReference + refPayco).then((response) => { 
                const date = new Date(response.data.data.x_transaction_date);
                setTransactionState({
                    refEpayco: response.data.data.x_ref_payco,
                    cardNumber: response.data.data.x_cardnumber,
                    transactionDate: date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear(),
                    transactionTime: date.getHours() + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()),
                    paymentMethodId: response.data.data.x_franchise,
                    isTestTransaction: parseTestRequest(response.data.data.x_test_request)
                })
            }).catch(() => {

            })
    }, [idCart, refPayco])


    useEffect(() => {
		dispatch(callDataConfingClientOwner(path));
        dispatch(handleFetchPurchase(idCart, `${domain}/vende/${homeState.catalogueUrlName}`, window.location, history, homeState.default_language))
    }, [idCart])

    const [items, setItems] = useState<any>([])

    const buildFallbackReferenceData = (product: any, itemRef: any) => {
        const fallbackAmount = Number(itemRef?.amount ?? itemRef?.valor ?? 0);
        return {
            id: itemRef?.id ?? null,
            amount: fallbackAmount,
            netAmount: fallbackAmount,
            discountPrice: fallbackAmount,
            discountRate: Number(itemRef?.discountRate ?? itemRef?.porcentaje_descuento ?? 0),
            tax: Number(itemRef?.tax ?? itemRef?.iva ?? 0),
            consumptionTax: Number(itemRef?.consumptionTax ?? itemRef?.ipoconsumo ?? 0),
            img: itemRef?.img ?? itemRef?.imagen ?? product?.productData?.img?.[0] ?? '',
            title: itemRef?.title ?? itemRef?.titulo ?? itemRef?.name ?? '',
        };
    };

    useEffect(() => {
        let isMounted = true;

        const buildPurchaseItems = async () => {
            const productsRefs = purchase.products.filter(
                (item: any) => item.references && item.references.length > 0
            );
            const productsData = purchase.products
                .filter((item: any) => !(item.references && item.references.length > 0))
                .map((product: any) => ({
                    ...product,
                    productData: { ...product.productData },
                }));

            if (productsRefs.length > 0) {
                productsRefs.forEach((product: any) => {
                    product.references.forEach((itemRef: any) => {
                        const productReferencesData = Array.isArray(product?.productData?.references)
                            ? product.productData.references
                            : [];
                        const refData = productReferencesData.find(
                            (field: any) => String(field?.id ?? '') === String(itemRef?.id ?? '')
                        );
                        const fallbackReferenceData = buildFallbackReferenceData(product, itemRef);
                        productsData.push({
                            ...product,
                            productData: { ...product.productData },
                            references: [{ ...itemRef, data: refData ? { ...fallbackReferenceData, ...refData } : fallbackReferenceData }],
                        });
                    });
                });
            }

            const needsSetupById = Array.from(
                new Set(
                    productsData
                        .filter(
                            (product: any) =>
                                product.productData?.id &&
                                (!Array.isArray(product.productData?.setupReferences) ||
                                    product.productData.setupReferences.length === 0)
                        )
                        .map((product: any) => String(product.productData.id))
                )
            );

            if (needsSetupById.length === 0) {
                if (isMounted) setItems(productsData);
                return;
            }

            const setupReferencesById: Record<string, any[]> = {};

            await Promise.all(
                needsSetupById.map(async (productId: string) => {
                    try {
                        const response = await Axios.post(
                            `${config.apiElastic}/catalogue/products`,
                            {
                                url: path,
                                filter: {
                                    name: 'id',
                                    value: Number(productId),
                                    manage: 1,
                                    origin: config.landingIdentifier,
                                    id: Number(productId),
                                },
                                optimice: true,
                            },
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Accept: 'application/json',
                                    version: 2,
                                },
                            }
                        );

                        const setupRefs = response?.data?.data?.[0]?.setupReferences;
                        if (Array.isArray(setupRefs) && setupRefs.length > 0) {
                            setupReferencesById[productId] = setupRefs;
                        }
                    } catch (_) {
                    }
                })
            );

            const productsWithSetup = productsData.map((product: any) => {
                const productId = String(product.productData?.id ?? '');
                if (!setupReferencesById[productId]) return product;
                return {
                    ...product,
                    productData: {
                        ...product.productData,
                        setupReferences: setupReferencesById[productId],
                    },
                };
            });

            if (isMounted) setItems(productsWithSetup);
        };

        buildPurchaseItems();

        return () => {
            isMounted = false;
        };
    }, [purchase.products])


    useEffect(() => {


        // const subTotal = items.map((cartProduct: any) => {
        //     let quantity = cartProduct.quantity;
        //     let price = cartProduct.productData.netAmount;
        //     if (cartProduct.references && cartProduct.references.length) {
        //         price = cartProduct.references[0].data.netAmount 
        //         quantity = cartProduct.references[0].quantity
        //     }
        //     return quantity * price;
        //   })?.reduce((acc: number, next: number) => (acc + next), 0);

        // if (subTotal)
        //     setSubTotalAmount(subTotal);

        const subTotal = items
				.map((cartProduct: any) => {
					let quantity = cartProduct.quantity;
                    const referenceData = cartProduct.references?.[0]?.data ?? {};
					let price =
						cartProduct.productData.netAmount !== 0 &&
						cartProduct.productData.discountPrice !== 0
							? cartProduct.productData.discountPrice
							: cartProduct.productData.amount;
					if (cartProduct.references && cartProduct.references.length) {
						price =
							referenceData.netAmount !== 0 &&
							referenceData.discountPrice !== 0
								? referenceData.discountPrice
								: referenceData.amount;
						quantity = cartProduct.references[0].quantity;
					}
					return Number(quantity) * Number(price ?? 0);
				})
				?.reduce((acc: any, next: any) => acc + next, 0);

			setSubTotalAmount(subTotal || 0);
	        
	        const totalDiscount = items.map((cartProduct: any) => {
	            let quantity = cartProduct.quantity
                const referenceData = cartProduct.references?.[0]?.data ?? {};
	            let discount = cartProduct.productData.netAmount !== 0 && cartProduct.productData.discountPrice !== 0 ?  cartProduct.productData.netAmount - cartProduct.productData.discountPrice : 0
	            if(cartProduct.references && cartProduct.references.length) {
	                quantity = cartProduct.references[0].quantity
	                discount = referenceData.netAmount !== 0 && referenceData.discountPrice !== 0 ? referenceData.netAmount - referenceData.discountPrice : 0
	             }
	            return (Number(quantity) * Number(discount))

	        })?.reduce((acc: number, next: number) => (acc + next), 0);

            setTotalDiscountAmount((totalDiscount || 0) + Number(purchase.discountAmount || 0));
        
        loadCheckout(() => {
            setLoadScript(false);
        });

    }, [items])

    const [pdf, setPdf] = useState(false);
    const handlePrint = () => {
        setPdf(!pdf);
    }

    const getStatus = () => {
        if (purchase.cartState === 'procesando_pago')
            return 'pending'
        else if (purchase.cartState === 'pagado')
            return 'success'

        return 'error'
    }

      const getTotalProducts = () => {
          const quantitiesArray = purchase.products.flatMap((cartProduct: any) => {
            if (cartProduct.references) {
              return cartProduct.references.map((reference: any) => reference.quantity);
            } else {
              return [cartProduct.quantity];
            }
          });
      
          const totalQuantity = quantitiesArray.reduce((acc: number, quantity: number) => acc + quantity, 0);
          return totalQuantity;
      }
      

    const getFranchise = (franchiceId: string) => {
        switch (franchiceId) {
            case 'AM': return 'Amex'
            case 'BA': return 'Baloto'
            case 'CR': return 'Credencial'
            case 'DC': return 'Diners Club'
            case 'EF': return 'Efecty'
            case 'GA': return 'Gana'
            case 'PR': return 'Punto Red'
            case 'RS': return 'Red Servi'
            case 'MC': return 'Mastercard'
            case 'SP': return 'SafetyPay'
            case 'VS': return 'Visa'
            case 'PSE': return 'PSE'
            default: return ''
        }
    }

    const handleCheckout = async() => { 
        if(loading) return;
        setLoading(true);
        // Solo se revalida: reenviar handleShipCart sobrescribiría el envío del carrito,
        // porque el comprobante no trae los datos completos (apellido, documento, cupones...)
        const validationResponse: any = await dispatch(validateShoppingCart(idCart, `${domain}/vende/${homeState.catalogueUrlName}`) as any);
        const validationError = getCartValidationError(validationResponse);
        if (validationError) {
            setLoading(false);
            setCartValidation(validationError);
            return;
        }
        // let costDevelivery = 0
        // if (shippingInfo && shippingInfo['472'] != null && !homeState.freeDelivery) {
        //     costDevelivery +=shippingInfo['472'].costo_total
        // }
        // if (shippingInfo && shippingInfo['tcc'] != null && !homeState.freeDelivery) {
        //     costDevelivery +=shippingInfo['tcc'].costo_total
        // }

        try{
            await EpaycoCheckout(idCart, purchase.clientId , homeState.catalogueName, purchase.products, shippingInfo, purchase.totalAmount, purchase.detailTotal.baseTax, purchase.detailTotal.taxAmount, purchase.detailTotal.consumptionTaxAmount, totalDiscountAmount, purchase.detailTotal.discountCode, purchase.contactName, purchase.contactEmail, purchase.contactPhone, purchase.address, purchase.publicKey, homeState.currency, "", () => {
                setLoading(false)
            }, homeState.configDataOwner?.integrationPhase);
        }catch(errorResponse)
        {
            setLoading(false);
            error(`${language[homeState.default_language]["transactionError"]}`);

        }
       
    }

    // shipping info
    payment = ShippingDetail(purchase);
    const shippingWasFree = wasShippingFree({
        totalPaid: purchase.totalAmount,
        subtotal: subTotalAmount,
        taxes: purchase.taxAmountTotal + purchase.consumptionTaxAmountTotal,
        couponDiscount: purchase.detailTotal?.discountCode ?? 0,
        shippingCost: purchase?.shippingCost ?? 0,
    });
    let shippingInfo = ShippingInfo(purchase);

    // end shipping info
   
    //  printer module active

    function endPrint(){
        setPdf(!pdf);
    }
    
    // end printer

    const mappingImgRef = (img: string, imgProduct: string) => {
        return img !== "" ? img : imgProduct
    }

    const getImageSrc = (product: any, mappingImgRef: Function) => {
        const productImg = product?.productData?.img?.[0] ?? '';
        const referenceImg = product?.references?.[0]?.data?.img;
        if (
            product.references &&
            product.references.length > 0 &&
            typeof referenceImg === 'string' &&
            referenceImg !== '' &&
            !referenceImg.endsWith('/null')
        ) {
          return mappingImgRef(referenceImg, productImg) || productImg;
        } else {
          return productImg;
        }
      }
    
    const contactEcommerce = { 
        email: homeState.contactEmail,
        phone: homeState.contactPhone,
    };

    const isAveonlineOrder = purchase.isAveonline === true || Boolean(purchase.guideId);

    // El modo prueba es una propiedad de la transaccion, no del estado actual del comercio.
    // Manda invoice.test (siempre viene con la compra); si faltara, se usa x_test_request
    // de la validacion por ref_payco. Ante la duda se asume produccion.
    const isTestTransaction =
        parseInvoiceTest(purchase.invoice?.test) ??
        transactionState.isTestTransaction ??
        false;

    return (
        <div>
            {
                pdf ?
                    <>
                      <LoadContainer>
                        <Spinner color={homeState.color} />
                    </LoadContainer>
                    {isAveonlineOrder ? (
                        <PurchasePdfAveonline
                            purchase={purchase}
                            transactionState={transactionState}
                            homeState={homeState}
                            payment={payment}
                            items={items}
                            status={getStatus()}
                            contactEcommerce={contactEcommerce}
                            onClose={() => setPdf(false)}
                            isTestTransaction={isTestTransaction}
                        />
                    ) : (
                    <PurchasePdf
                        subtotal = {subTotalAmount}
                        total = {payment}
                        purchase={purchase}
                        color={homeState.color}
                        transaction={transactionState.refEpayco}
                        shipping={shippingInfo}
                        discount={purchase.discountAmount}
                        epaycoMultimedia={epaycoMultimedia}
                        transactionState={transactionState}
                        catalogue={homeState.catalogueName}
                        commerce={homeState.companyName}
                        delivery={homeState.freeDelivery}
                        onClose={()=> setPdf(false)}
                        contactEcommerce={contactEcommerce}
                    />
                    )}
                </> :
                <>
                {!purchase.loading && !loadScript && isAveonlineOrder ? (
                    <Body>
                        <PurchaseDetailAveonline
                            purchase={purchase}
                            transactionState={transactionState}
                            homeState={homeState}
                            payment={payment}
                            items={items}
                            idCart={idCart}
                            handlePrint={handlePrint}
                            status={getStatus()}
                            handleCheckout={handleCheckout}
                            loading={loading}
                            isTestTransaction={isTestTransaction}
                        />
                    </Body>
                ) : (
                <Body>
                    <WhiteContainer style={getStatus() === 'error' ? { background: 'transparent', boxShadow: 'none', margin: '0' } : undefined}>
                        {purchase.loading || loadScript ? <LoadContainer>
                            <Spinner color={homeState.color} />
                            </LoadContainer> : <>
                                {getStatus() === 'error' ?
                                    <ErrorStateCard $accentColor={homeState.color}>
                                        <ErrorStateSurface>
                                            <StatusMessage status={getStatus()} color={homeState.color} />
                                            <ErroContainer>
                                                <MainButton color={homeState.color} loading={loading} onClick={handleCheckout}>{language[homeState.default_language]["chooseOtherPaymentMethod"]}</MainButton>
                                                <CancelButton type="button" onClick={() => history.push(`/vende/${homeState.catalogueUrlName}/carrito/${idCart}`)}>
                                                    {language[homeState.default_language]["cancel"]}
                                                </CancelButton>
                                            </ErroContainer>
                                        </ErrorStateSurface>
                                    </ErrorStateCard>
                                    :
                                    <>
                                        <StatusMessage status={getStatus()} color={homeState.color} />
                                        <ButtonsActions>
                                            <MainButton
                                                color={homeState.color}
                                                secondary={false}
                                                type="button"
                                                onClick={() => {
                                                    handlePrint()
                                                  }
                                                }
                                            >
                                                <CustomIcon color='white' type='printer' size='15px'/>
                                                <span>{language[homeState.default_language]["print"]}</span>
                                            </MainButton>
                                            <MainButton
                                                color={homeState.color}
                                                secondary={false}
                                                type="button"
                                                onClick={ () => {
                                                    history.push(`/vende/${homeState.catalogueUrlName}`)
                                                }
                                                }
                                            >
                                                {language[homeState.default_language]["backShoping"]}
                                            </MainButton>
                                        </ButtonsActions>
                                        <Title color={homeState.color}>{`${language[homeState.default_language]["summaryPurchase"]} ${transactionState.refEpayco ? transactionState.refEpayco : ''}`}</Title>
                                        <InvoiceContainer>
                                            <InfoCardContainer>
                                                <div>
                                                    <PurchaseResumeInfo>
                                                        <div>
                                                            <div>{language[homeState.default_language]["subtotal"]} {((purchase.taxAmountTotal !== 0 || purchase.consumptionTaxAmountTotal !== 0 ) ? " + "+language[homeState.default_language]["tax"] : "")}</div>
                                                            <div>
                                                                <CurrencyFormat amount={subTotalAmount + ((purchase.taxAmountTotal !== 0 || purchase.consumptionTaxAmountTotal !== 0 ) ? purchase.taxAmountTotal + purchase.consumptionTaxAmountTotal : 0)} />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div>
                                                                {language[homeState.default_language]["cost"]}{" "}
                                                                {language[homeState.default_language]["send"]}
                                                            </div>
                                                            <div>
                                                                {shippingWasFree ? (
                                                                    language[homeState.default_language]["free"]
                                                                ) : (
                                                                    <CurrencyFormat
                                                                        amount={purchase?.shippingCost ?? 0}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                       {purchase.detailTotal.discountCode !== 0 && <>
                                                            <div>
                                                                <div>{language[homeState.default_language]["discount"]}</div>
                                                                <div>
                                                                    <DiscountColoredText>
                                                                        - <CurrencyFormat amount={purchase.detailTotal.discountCode} />
                                                                    </DiscountColoredText>
                                                                </div>
                                                            </div>  
                                                       </>}
                                                            {
                                                                purchase.shipping && purchase.shipping['472'] != null && !homeState.freeDelivery &&
                                                                <>
                                                                <div>
                                                                    <div>{language[homeState.default_language]["FourSevenTwoShipping"]}</div>
                                                                    <div>
                                                                        <CurrencyFormat amount={shippingInfo['472'].costo_total} />
                                                                    </div>
                                                                </div>
                                                                </>
                                                            }   
                                                        {
                                                            purchase.shipping && purchase.shipping['tcc'] != null && !homeState.freeDelivery &&
                                                                <>
                                                                    <div>
                                                                        <div>{language[homeState.default_language]["send"]}  {shippingInfo['tcc'].operador} </div>
                                                                        <div>
                                                                            <CurrencyFormat amount={shippingInfo['tcc'].costo_total} />
                                                                        </div>
                                                                    </div>
                                                                </>
                                                        }
                                                        {
                                                            (homeState.freeDelivery && purchase.shipping && purchase.shipping['472'] != null) ||  (homeState.freeDelivery && purchase.shipping && purchase.shipping['tcc'] != null) ?
                                                            <>
                                                                <div>
                                                                    <div>{language[homeState.default_language]["send"]} {shippingInfo['472'].operador}</div>
                                                                    <div>
                                                                    {language[homeState.default_language]["free2"]}
                                                                    </div>
                                                                </div>
                                                            </> : <></>
                                                        }
                                                        <div id='last'>
                                                            <div> {language[homeState.default_language]["total"]}</div>
                                                            <div>
                                                                <CurrencyFormat amount={Math.abs(payment)} />
                                                            </div>
                                                        </div>
                                                    </PurchaseResumeInfo>
                                                    {
                                                        transactionState.paymentMethodId && transactionState.cardNumber && <>
                                                            <PaymentInfo>
                                                                <div>
                                                                    <PaymentMethodImg src={epaycoMultimedia + 'cards/' + (transactionState.paymentMethodId ? transactionState.paymentMethodId :  purchase.invoice?.franquicia) + '.png'} />
                                                                </div>
                                                                <div>
                                                                    <div>
                                                                        {transactionState.paymentMethodId && transactionState.cardNumber && <>
                                                                            {`${getFranchise(transactionState.paymentMethodId)} ${transactionState.cardNumber !== '*******' ? transactionState.cardNumber.substr(6) : ''}`}
                                                                            </>
                                                                        }
                                                                                
                                                                        
                                                                        <br></br>
                                                                        {language[homeState.default_language]["pay"]} <CurrencyFormat amount={Math.abs(payment)} />
                                                                        <br></br>
                                                                        {transactionState.paymentMethodId && transactionState.cardNumber &&
                                                                            <div style={{ color: '#C4C4C4' }}>
                                                                                {`${language[homeState.default_language]["paymentNumber"]} ${query.get('ref_payco')?.substring(0, 5)}`}
                                                                                <br></br>
                                                                                {`${language[homeState.default_language]["transactionDate"]} ${transactionState.transactionDate} `}
                                                                                {`${language[homeState.default_language]["hour"]} ${transactionState.transactionTime}`}
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </PaymentInfo>
                                                        </>
                                                    }
                                                    <AddressInfo>
                                                        <div>
                                                            <svg data-src={`${config.urlMultimedia}/vende/landing-img/marker.svg`}/>
                                                        </div>
                                                        <div>
                                                            <div>
                                                                {`${language[homeState.default_language]["address"]}: ${purchase.address}`}
                                                                <br></br>
                                                                {`${language[homeState.default_language]["receives"]}: ${purchase.contactName}`}
                                                                <br></br>
                                                                {`${language[homeState.default_language]["phone"]}: ${purchase.contactPhone}`}
                                                                <br></br>
                                                                {`${language[homeState.default_language]["email"]}: ${purchase.contactEmail}`}
                                                            </div>
                                                        </div>
                                                    </AddressInfo>
                                                </div>
                                                <ProductsPurchasedContainer>
                                                    {
                                                        items.map((product: any) => {
                                                            return (
                                                                <ProductPurchasedCard key={uuid()}>
                                                                    <ProductPurchasedImage src={getImageSrc(product, mappingImgRef)} />
                                                                    <ProductPurchasedInfo>
                                                                        <div style={{
                                                                            fontFamily: 'Raleway',
                                                                            fontStyle: 'normal',
                                                                            fontWeight: 400,
                                                                            fontSize: '18px',
                                                                            lineHeight: '21px',
                                                                        }}>

                                                                        {product.productData.title}
                                                                        </div>
                                                                        { product.references && product.references.length > 0 
                                                                            && 
                                                                        <div>
                                                                            <b style={{
                                                                                fontFamily: 'Open Sans',
                                                                                fontStyle: 'normal',
                                                                                fontWeight: 700,
                                                                                fontSize: '14px',
                                                                                lineHeight: '19px',
                                                                            }}>{language[homeState.default_language]["ref"]}: </b>
                                                                            <p className='purchase-detail-product-reference' style={{color: '#999999'}}>{product.references[0].data.title}</p>
                                                                        </div>
                                                                          }
                                                                        { findAmountProduct(product, 'discountRate') > 0 &&
                                                                            <>
                                                                                <RegularPrice>
                                                                                <CurrencyFormat
                                                                                    amount={calculatePriceWithTax(product.references && product.references.length > 0 ? product.references[0].data : product.productData)}
                                                                                />
                                                                                </RegularPrice>
                                                                            </>
                                                                        }
                                                                        { product.references && product.references.length > 0  ?
                                                                        <div>
                                                                            <span
                                                                                style={{
                                                                                fontFamily: 'Open Sans',
                                                                                fontStyle: 'normal',
                                                                                fontWeight: 700,
                                                                                fontSize: '16px',
                                                                                lineHeight: '22px',
                                                                              }} 
                                                                            >
                                                                                <CurrencyFormat amount={product.references[0].data.amount !== 0 ? product.references[0].data.amount : product.references[0].data.netAmount} />
                                                                            </span>
                                                                            
                                                                            <span style={{
                                                                                color: '#999999',
                                                                                fontFamily: 'Open Sans',
                                                                                fontStyle: 'normal',
                                                                                fontWeight: 400,
                                                                                fontSize: '16px',
                                                                                lineHeight: '22px'
                                                                            }}>
                                                                                {`  x ${product.references[0].quantity} ${language[homeState.default_language]["unit"]}`}
                                                                            </span>
                                                                        </div>
                                                                            :
                                                                        <div>
                                                                             <span
                                                                                style={{
                                                                                fontFamily: 'Open Sans',
                                                                                fontStyle: 'normal',
                                                                                fontWeight: 700,
                                                                                fontSize: '16px',
                                                                                lineHeight: '22px',
                                                                              }} 
                                                                            >
                                                                                <CurrencyFormat amount={product.productData.amount !== 0 ? product.productData.amount : product.productData.netAmount} />
                                                                            </span>
                                                                            <span style={{
                                                                                color: '#999999',
                                                                                fontFamily: 'Open Sans',
                                                                                fontStyle: 'normal',
                                                                                fontWeight: 400,
                                                                                fontSize: '16px',
                                                                                lineHeight: '22px'
                                                                            }}>{`  x ${product.quantity} ${language[homeState.default_language]["units"]}`}
                                                                            </span>
                                                                        </div>
                                                                            }

                                                                
                                                                    </ProductPurchasedInfo>
                                                                </ProductPurchasedCard>
                                                            )
                                                        })
                                                    }
                                                </ProductsPurchasedContainer>
                                            </InfoCardContainer>
                                        </InvoiceContainer>
                                    </>
                                }
                            </>}
                            </WhiteContainer>
                            { getStatus() !== 'error' && <MainButton onClick={() => {
                                history.push('/')
                            }} color={homeState.color} style={{ display: 'block', margin: '10px auto' }}>{language[homeState.default_language]["goToHomePage"]}</MainButton>}
                </Body>
                )}
                </>
            }
            <CartValidationModal
                open={!!cartValidation}
                color={homeState.color}
                defaultLanguage={homeState.default_language}
                result={cartValidation}
                onAccept={() => {
                    const storeInactive = cartValidation?.inactiveStore;
                    setCartValidation(null);
                    if (storeInactive) {
                        dispatch({ type: INACTIVE_CATALOGUE });
                        return;
                    }
                    history.push(`/vende/${homeState.catalogueUrlName}/carrito/${idCart}`);
                }}
            />
        </div>
    )
}

export default PurchaseDetail;
